import React, { Component } from 'react';
import * as Styles from './Styles';
import { ConnectedProps, connect } from 'react-redux';
import { AppState } from '../../core/Store';
import { Routing } from '../../core/Routing';
import * as AppManager from '../../reducers/ui/app';

type State = {};

class BannerComponent extends Component<PropsFromRedux, State> {
	state = {};

	componentWillUnmount(): void {
		this.props.resetPaymentStatus();
	}

	render() {
		return (
			<Styles.Wrapper>
				<Styles.ContentContainer>
					<Styles.HeadingsContainer>
						<Styles.HeadingFont>
							<span>Sukces!</span>
						</Styles.HeadingFont>
						<Styles.HeadingFont>
							płatność zrealizowana pomyślnie!
						</Styles.HeadingFont>
						<Styles.GenericFont style={{ marginTop: '36px' }}>
							Twoje ubezpieczenie zostało opłacone i będzie
							aktywne od wybranego wcześniej terminu
						</Styles.GenericFont>
						<Styles.GenericFont style={{ marginTop: '6px' }}>
							Możesz bezpiecznie zamknąć tą kartę lub wrócić na
							<a href={Routing.main.start}>stronę główną</a>
						</Styles.GenericFont>
					</Styles.HeadingsContainer>
				</Styles.ContentContainer>
			</Styles.Wrapper>
		);
	}
}

interface Own {}

const connector = connect(
	(state: AppState, own: Own) => ({}),
	(dispatch) => ({
		resetPaymentStatus: () =>
			dispatch(AppManager.Actions.setPaymentStatus('pending')),
	})
);

export type PropsFromRedux = ConnectedProps<typeof connector> & Own;

const Banner = connector(BannerComponent);
export default Banner;
